import { Space } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { validateNotEmpty } from './utils'
import { Tooltip } from 'antd'
interface InputProps {
  required?: boolean
  source: string
  optionName?: string
  optionValue?: string
  disabled?: boolean
  validate?: (value: string | string[]) => string | undefined
  label?: string
  placeholder?: string
  showLabel?: boolean
  toolTipMsg?: string
  autoSize?: Record<'minRows' | 'maxRows', number> | false
  handleOnChange?: (value: string) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
  onPressEnter?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

export const Input: FC<InputProps> = (props) => {
  const {
    source,
    disabled = false,
    validate,
    label = '',
    required = false,
    placeholder = 'Please enter',
    autoSize = { minRows: 1, maxRows: 5 },
    handleOnChange,
    onKeyDown,
    onPressEnter,
    toolTipMsg,
    showLabel = true,
  } = props
  const { control } = useFormContext()
  const { t } = useTranslation()

  const handlePressEnter = (
    event: React.KeyboardEvent<HTMLTextAreaElement>,
  ) => {
    event.preventDefault()
    if (onPressEnter) {
      onPressEnter(event)
    }
  }

  return (
    <Space direction="vertical" size={0} style={{ width: '100%' }}>
      {showLabel && (
        <Tooltip title={toolTipMsg} zIndex={999999}>
          <label className="form-label">
            {t(label)}
            {required && <span className="text-danger"> *</span>}
          </label>
        </Tooltip>
      )}
      <Controller
        control={control}
        name={source}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <div>
              <TextArea
                autoSize={autoSize}
                disabled={disabled}
                placeholder={t(placeholder)}
                value={value}
                onKeyDown={onKeyDown}
                onPressEnter={handlePressEnter}
                onChange={(e) => {
                  onChange(e.target.value)
                  if (handleOnChange) {
                    handleOnChange(e.target.value)
                  }
                }}
              />
              {error && <div style={{ color: 'red' }}>{error.message}</div>}
            </div>
          )
        }}
        rules={{
          validate: (value) => {
            if (required) {
              return validate ? validate(value) : validateNotEmpty(value)
            }
            return true
          },
        }}
      />
    </Space>
  )
}
